import 'moment/locale/es';

import i18n from 'i18next';
// import HttpApi from 'i18next-http-backend';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

const enTranslation = require('@sophocles/locales/en.json');
const esTranslation = require('@sophocles/locales/es.json');

const browserLanguage = navigator.language ?? navigator.languages[0] ?? 'en-US';

const updateMomentLocale = lng => {
  const localeMap = {
    'en-US': 'en',
    en: 'en',
    'es-ES': 'es',
    es: 'es',
  };

  const momentLocale = localeMap[lng] || 'en'; // Default to English
  moment.locale(momentLocale);
  console.debug(`Moment.js locale updated to: ${momentLocale}`);
};

const resources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
};

i18n
  //.use(HttpApi) // Load translations via HTTP
  .use(initReactI18next) // Pass i18n instance to React
  .init({
    resources,
    lng: browserLanguage, // Auto-detect browser language on first load
    supportedLngs: ['en-US', 'es-ES', 'en', 'es'],
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    debug: false, // Enable debug mode for development
    backend: {
      loadPath: '/public/locales/{{lng}}.json', // Translation file path
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'], // Cache user language preferences
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', updateMomentLocale);

export const setLanguage = language => {
  i18n.changeLanguage(language);
};

export default i18n;
